/* global axios */
import ApiClient from './ApiClient';

class SystemAssistantAPI extends ApiClient {
  constructor() {
    super('system_assistant', { accountScoped: true });
  }

  toggle(enabled) {
    return axios.patch(this.url, { enabled });
  }

  handoff(conversationId) {
    return axios.post(`${this.url}/handoff`, {
      conversation_id: conversationId,
    });
  }

  configureInbox(data) {
    return axios.put(`${this.url}/inbox`, data);
  }

  preview(data) {
    return axios.post(`${this.url}/preview`, data);
  }

  setQuota(monthlyLimit) {
    return axios.patch(`${this.url}/quota`, { monthly_limit: monthlyLimit });
  }

  get platformUrl() {
    return `${this.apiVersion}/platform/system_assistant`;
  }

  getPlatform() {
    return axios.get(this.platformUrl);
  }

  savePlatform(data) {
    return axios.patch(this.platformUrl, data);
  }

  openLangflow() {
    return axios.post(`${this.platformUrl}/langflow_session`);
  }

  testPlatform() {
    return axios.post(`${this.platformUrl}/test_connection`);
  }
}

export default new SystemAssistantAPI();
